import * as React from 'react';

const InfoInCircle = ({
  backgroundColor = 'inherit',
  iconColor = 'rgba(14, 19, 35, 0.35)',
}) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="30" height="30" rx="15" fill={backgroundColor} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 8C11.1546 8 8 11.1546 8 15C8 18.8454 11.1546 22 15 22C18.8454 22 22 18.8454 22 15C22 11.1546 18.8454 8 15 8ZM6 15C6 10.05 10.05 6 15 6C19.95 6 24 10.05 24 15C24 19.95 19.95 24 15 24C10.05 24 6 19.95 6 15ZM15 14C14.4 14 14 14.4 14 15V18C14 18.6 14.4 19 15 19C15.6 19 16 18.6 16 18V15C16 14.4 15.6 14 15 14ZM16 12C16 12.5523 15.5523 13 15 13C14.4477 13 14 12.5523 14 12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12Z"
      fill={iconColor}
    />
  </svg>
);
export default InfoInCircle;
